// 临时占位数据，后续会被接口返回的数据替换
export const stepsData = [
  {
    id: 1,
    stepValue: 1,
    stepName: 'Car type',
    title: 'Select car type',
    activeStep: true,
    category: 'carType',
    items: [
      {
        id: 11,
        title: 'JAECOO 7 PETROL',
        selected: true,
        image: '/images/placeholder-car.png',
        category: 'firstCar',
        price: 30115,
      },
      {
        id: 12,
        title: 'JAECOO 7 SHS (Plug-in Hybrid)',
        selected: false,
        image: '/images/placeholder-car.png',
        category: 'secondCar',
        price: 35165,
      },
    ],
  },
  {
    id: 2,
    stepValue: 2,
    stepName: 'Version',
    activeStep: false,
    category: 'version',
    items: [
      {
        id: 21,
        title: 'Deluxe',
        price: 0,
        selected: true,
        innerItems: [
          { id: 211, text: 'FWD' },
          { id: 212, text: '13.2" Portrait Central LCD Display' },
          { id: 213, text: '6 speaker audio system' },
        ],
      },
      {
        id: 22,
        title: 'Luxury',
        price: 3830,
        selected: false,
        innerItems: [
          { id: 221, text: 'AWD' },
          { id: 222, text: '14.8" Portrait Central LCD Display' },
          { id: 223, text: 'SONY 8 speaker sound system' },
          { id: 224, text: 'PM2.5 Air Purification' },
          { id: 225, text: 'Exterior rearview mirror & seat' },
        ],
      },
    ],
  },
  {
    id: 3,
    stepValue: 3,
    stepName: 'Colour',
    title: 'Select colour',
    activeStep: false,
    category: 'colour',
    carTypes: {
      firstCar: {
        category: 'firstCar',
        selected: true,
        items: [
          {
            id: 38,
            selected: true,
            color: '/images/placeholder-color.png',
            image: '/images/placeholder-car.png',
            colorName: 'Granite White',
            price: 0,
          },
        ],
      },
      secondCar: {
        category: 'secondCar',
        selected: false,
        items: [
          {
            id: 38,
            selected: true,
            color: '/images/placeholder-color.png',
            image: '/images/placeholder-car.png',
            colorName: 'Granite White',
            price: 0,
          },
        ],
      },
    },
  },
  {
    id: 4,
    stepValue: 4,
    stepName: 'Summary',
    title: 'Summary',
    activeStep: false,
    category: 'summary',
    items: [
      { id: 41, text: 'Car type', category: 'carType' },
      { id: 42, text: 'Version', category: 'version' },
      { id: 43, text: 'Colour', category: 'colour' },
      { id: 44, text: 'Estimated price', category: 'estimatedPrice' },
    ],
  },
];

// 添加默认导出以兼容componentBuilder.js
export default stepsData;
